import React from 'react'
import { useState, useRef, useEffect } from 'react';
import { Modal, Input, AutoComplete, Select } from 'antd';
import {
  SubHeading,
} from "components/Typography";
import { updatepdf, subjectFilter, fetchAdminLibraryData, updateSetType, fetchAdminChapterFilter, fetchClasslist, postClone, fetchFilterTopic, fetchLibraryData, postCreateTopic, updateFilterTopic, updateAdminChapterInfo, updateTitle } from 'actions/digitalLibrary'
import { connect } from 'react-redux'
import { Button } from 'components/Button';


function CloneInformation({
  ismodelvisible,
  setmodevisible,
  updatepdf,
  subjectFilter, subjects,
  chapterstofetch,
  id, types, selectedSubject, selectedStd, chapterName, chapterId, fetchAdminLibraryData,
  updateSetType, fetchAdminChapterFilter, getChaptersList, fetchClasslist, getStdList, title, postClone, uploadContent
  , topicList, selectedChapter, fetchFilterTopic, selectedTopic, fetchLibraryData, contentPage, postCreateTopic,
  updateFilterTopic, updateAdminChapterInfo, updateTitle,changedTitle
}) {
  console.log("id2", topicList);
  var i = 0;
  const [subjectname, setSubjectName] = useState(null)
  const [inputvalue, setinputvalue] = useState('')
  const [chaptersarray, setchapterarray] = useState(getChaptersList)
  const [pdf, setpdf] = useState(null)
  const [chapter, setchapter] = useState('')
  const [classid, setclassid] = useState(null)
  const [subjectid, setsubjectid] = useState(null)
  const [chapterid, setchapterid] = useState(null)
  const [options, setOptions] = useState([]);
  const [searchChapter, setSearchChapter] = useState("")
  const [optionsChapter, setOptionsChapter] = useState([]);
  const [chapterLoader, setChapterLoader] = useState(false)
  const [subjectLoder, setSubjectLoader] = useState(false)
  const [className, setClassName] = useState(null)
  const [loader, setLoader] = useState(false)
  const [topicId, setTopicId] = useState(null)
  const [topicName, setTopicName] = useState(null)
  const [classLoader, setClassLoader] = useState(false)
  const [topicLoader, setTopicLoader] = useState(false)
  let [topicListToShow, setTopicListToShow] = useState([])
  const [createLoader, setCreateLoader] = useState(false)
  const [optionsBatch, setOptionsBatch] = useState([]);
  const [optionsTopic, setOptionsTopic] = useState([]);
  const inputchanged = (e) => {
    console.log(e, "e")
    updateTitle(e.target.value)
    setinputvalue(e.target.value)
  }
  const filteroptions = (val) => {
    const dummyArray = chapterstofetch.filter((element) => {
      return (element.name).toLowerCase().includes(val.toString().toLowerCase())
    }
    )

    setchapterarray(dummyArray)
  }

  const searchResult = (query, currentValue) =>
    query.map((item, index) => {
      const name = String(item.name || item.subjects_name || item.subjectname || '').trim();
      const isSelected = name === String(currentValue || '').trim();
      return {
        key: index,
        value: name,
        id: item.id || item.subjects_id || item.subjectId,
        style: isSelected ? { backgroundColor: '#C6C2FF', fontWeight: '600' } : {},
        label: name
      };
    });

  const searchResultBatch = (query, currentValue) =>
    query.map((item, index) => {
      const displayValue = String(`${item.std} - ${item.section}`).trim();
      const isSelected = displayValue === String(currentValue || '').trim();
      return {
        key: index,
        value: displayValue,
        id: item.id,
        style: isSelected ? { backgroundColor: '#C6C2FF', fontWeight: '600' } : {},
        label: displayValue,
        displayValue: displayValue
      };
    });

  const searchResultTopic = (query, currentValue) =>
    query.map((item, index) => {
      const name = String(item.name || '').trim();
      const isSelected = name === String(currentValue || '').trim();
      return {
        key: index,
        value: name,
        id: item.id,
        style: isSelected ? { backgroundColor: '#C6C2FF', fontWeight: '600' } : {},
        label: name,
        displayValue: name
      };
    });


  useEffect(() => {
    setOptions(subjects ? [...searchResult(subjects, subjectname)] : []);
  }, [subjects, subjectname])

  useEffect(() => {
    setOptionsChapter(getChaptersList ? [...searchResult(getChaptersList, searchChapter)] : []);
  }, [getChaptersList, searchChapter])

  useEffect(() => {
    setOptionsBatch(getStdList ? [...searchResultBatch(getStdList, className)] : []);
  }, [getStdList, className])

  useEffect(() => {
    let opts = topicListToShow ? [...searchResultTopic(topicListToShow, topicName)] : [];
    if (topicName && opts.length === 0) {
      opts.push({
        value: -1,
        label: <div>Create {topicName}</div>,
        displayValue: topicName
      });
    }
    setOptionsTopic(opts);
  }, [topicListToShow, topicName])

  useEffect(() => {

    if (selectedSubject && Object.keys(selectedSubject).length !== 0) {
      console.log("selectedSubject", selectedSubject);
      setsubjectid(selectedSubject.subjects_id ? selectedSubject.subjects_id : selectedSubject?.subjectId)
      setSubjectName(selectedSubject.subjects_name ? selectedSubject.subjects_name :selectedSubject.subjectname)
      // fetchClasslist(selectedSubject.subjects_id)
    }
    if (selectedStd && Object.keys(selectedStd).length !== 0) {
      console.log("selectedSubject", selectedStd);

      setclassid(selectedStd.std_id ? selectedStd.std_id : selectedStd.classid)
      setClassName(selectedStd.standard ? selectedStd.standard + '-' + selectedStd.std_section : selectedStd?.className)
    }
    if (selectedChapter && Object.keys(selectedChapter).length != 0 && selectedSubject && selectedStd) {
      setchapterid(selectedChapter.chapterId ? selectedChapter.chapterId : selectedChapter?.chapterid)
      setchapter(selectedChapter.chapterName)
      setSearchChapter(selectedChapter.chapterName)
      console.log("selectedChapter", selectedChapter);
      console.log("selectedChapter1", selectedSubject);
      console.log("selectedChapter2", selectedStd);

      fetchAdminChapterFilter('', selectedStd.std_id ? selectedStd.std_id : selectedStd.classid, selectedSubject.subjects_id ? selectedSubject.subjects_id : selectedSubject?.subjectId)
      fetchClasslist(selectedSubject.subjects_id ? selectedSubject.subjects_id : selectedSubject?.subjectId, selectedChapter.chapterName)
      
      fetchFilterTopic(selectedSubject.subjects_id ? selectedSubject.subjects_id : selectedSubject?.subjectId, selectedStd.std_id ? selectedStd.std_id : selectedStd.classid , selectedChapter.chapterId ? selectedChapter.chapterId : selectedChapter?.chapterid )
      // fetchFilterTopic(selectedSubject.subjects_id , selectedStd.std_id , selectedChapter.chapterId )


    }

    if (selectedTopic && Object.keys(selectedTopic).length != 0) {
      setTopicId(selectedTopic.topicId)
      setTopicName(selectedTopic.topicName)
    }
    console.log("title",title,inputvalue);
    if (title) {
      setinputvalue(title)
      updateTitle(title)
    }
    if (uploadContent && Object.keys(uploadContent).length !== 0) {
      console.log("uploadContent", uploadContent);
      setsubjectid(uploadContent.subjectId)
      fetchClasslist(uploadContent.subjectId)
      setSubjectName(uploadContent.subjectname)
      setclassid(uploadContent.classid)
      setClassName(uploadContent.className)
      setchapterid(uploadContent.chapterid)
      setchapter(uploadContent.chapterName)
      setSearchChapter(uploadContent.chapterName)

      setTopicId(uploadContent.topicId)
      setTopicName(uploadContent.topicName)

    }
  }, [])

  useEffect(() => {
    if (topicList?.length != 0) {
      setTopicListToShow(topicList)
    }
    else {
      setTopicListToShow([])
    }
  }, [topicList])

  const handleSearch = (value) => {
    if (!value) {
      setSubjectName('')
      setsubjectid(null)
    }
    else {
      setSubjectName(value)
      setSubjectLoader(true)
    }
    subjectFilter(value, () => setSubjectLoader(false))

  };

  const handleSearchChapter = (value) => {
    setTopicId(null)
    setTopicName(null)
    if (!value) {
      setSearchChapter('')
    }
    else {
      setSearchChapter(value)
      setChapterLoader(true)
    }
    fetchAdminChapterFilter(value, classid, subjectid, () => setChapterLoader(false))

  };

  const handleSearchBatch = (value) => {
    setClassName(value)
    if (!value) {
      setclassid(null)
    }
  }

  const onSelectBatch = (value, obj) => {
    setclassid(obj.id)
    setClassName(value)
    setChapterLoader(true)
    updateAdminChapterInfo([])
    setchapterid(null)
    setchapter('')
    setSearchChapter('')
    setTopicId(null)
    setTopicName(null)
    updateFilterTopic([])
    fetchAdminChapterFilter('', obj.id, subjectid, () => setChapterLoader(false))
    setchapterarray([...getChaptersList])
  }

  const onSelect = (value, obj) => {
    setSubjectName(value)
    setsubjectid(obj.id)
    setclassid(null)
    setClassName('')
    setchapterid(null)
    setchapter('')
    setSearchChapter('')
    if (obj.id == selectedSubject?.subjects_id) {
      setclassid(selectedStd?.std_id)
      setClassName(selectedStd?.standard + '-' + selectedStd?.std_section)
      setchapterid(chapterId)
      setchapter(chapterName)
      setSearchChapter(chapterName)

    }
    setClassLoader(true)
    fetchClasslist(obj.id, '', () => setClassLoader(false))
    fetchAdminChapterFilter('', classid, obj.id)

  };
  const onSelectChapter = (value, obj) => {
    updateFilterTopic([])
    setTopicId(null)
    setTopicName(null)
    setSearchChapter(value)
    setchapter(value)
    setchapterid(obj.id)
    setTopicLoader(true)
    fetchFilterTopic(subjectid, classid, obj.id, () => setTopicLoader(false))
  };

  const handleChangeChapter = (value, obj) => {
    setchapterid(null)
    setchapter('')
    setSearchChapter('')
    setTopicId(null)
    setTopicName(null)
    updateFilterTopic([])
    if (value) {
      setSearchChapter(value)
      setchapter(value)
    }
  }


  const successhandler = (e) => {
    e.stopPropagation()
    console.log("abcdef", classid, subjectid, topicId, chapterid);

    if (subjectid && chapterid && inputvalue && classid && chapter) {
      // var objectToUpload = {
      //   id: id,
      //   subjectId: subjectid,
      //   chapterId: parseInt(chapterid),
      //   title: inputvalue,
      //   standardId: parseInt(classid),
      //   type: types,
      //   chapterName: chapter

      // }
      updateSetType(types)
      console.log("abcdef", classid, id, topicId, chapterid);
      setLoader(true)

      postClone(classid, id, topicId, chapterid, () => setLoader(false), successCallback)

    }
  }

  const successCallback = () => {
    setLoader(false)
    setpdf(null)
    setinputvalue('')
    if (contentPage) {
      fetchLibraryData()
    }
    setmodevisible(false)
  }


  const handleCancel = (e) => {
    e.stopPropagation()
    updatepdf(null)
    setinputvalue('')
    setmodevisible(false);
  };

  const onSelectTopic = (value, obj) => {
    if (value != -1) {
      setTopicId(obj.id)
      setTopicName(value)
    }
    else if (value == -1) {
      let object = {
        chapterId: chapterid,
        topicName: obj.displayValue
      }
      setTopicName(null)
      postCreateTopic(object, () => setCreateLoader(false), successCallbackTopic)
    }
    else {
      setTopicId(null)
      setTopicName(null)
    }
  }

  const successCallbackTopic = () => {
    fetchFilterTopic(subjectid, classid, chapterid, () => setTopicLoader(false))
  }

  const handleChangeTopic = (value, obj) => {
    // console.log(value, obj)
    if (value != -1) {
      setTopicId(value)
      setTopicName(obj?.children)
    }
    else if (value == -1) {
      setTopicName(null)
    }
    else {
      setTopicId(null)
      setTopicName(null)
    }
    fetchFilterTopic(subjectid, classid, chapterid, () => setTopicLoader(false))
  }

  const handleSearchTopic = (value) => {
    // console.log(value)
    if (value && value.trim() != '') {
      setTopicName(value)
      let topic;
      topic = topicList.filter((item) => item.name.toLowerCase().includes(value.toLowerCase()))
      setTopicListToShow(topic)
      setTopicId(null)
    }
    else {
      setTopicId(null)
      setTopicName(null)
      setTopicListToShow(topicList)
    }
  }





  return (
    <Modal className='rounded-border' width='60%' visible={ismodelvisible} footer={null} onCancel={handleCancel} maskClosable={false}>
      <div onClick={(e) => e.stopPropagation()}>
        <div className='lecturenotestitle' style={{ width: '100%', textAlign: 'center' }}>
          <p>Clone Information</p>
        </div>
        <div className='lecturnotesdescription' style={{ width: '100%', textAlign: 'center' }}>
        </div>
        <div style={{ display: 'flex', height: '400px', justifyContent: 'space-between' }}>
          <div className='uploadsearchbox' style={{ width: '100%' }}>
            <div className='full-width'>
              <p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Subject</p>

              <AutoComplete
                allowClear={true}
                dropdownMatchSelectWidth={252}
                className='autocompletetoupload'
                options={options}
                value={subjectname}
                onSelect={onSelect}
                onSearch={handleSearch}
                disabled={true}
                loading={subjectLoder}
              >
                <Input size="middle" style={{ background: '#FAFAFA 0% 0% no-repeat padding-box', border: 'none', width: '100%' }} placeholder="Select subject" />
              </AutoComplete>
            </div>
            <div className='udloadFilesDropdown' style={{ width: '100%' }}>
              <p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Batch</p>
              <AutoComplete
                getPopupContainer={(trigger) => trigger.parentElement}
                allowClear={className ? true : false}
                dropdownMatchSelectWidth={252}
                options={optionsBatch}
                value={className}
                onSelect={onSelectBatch}
                onSearch={handleSearchBatch}
                filterOption={false}
                className='autocompletetoupload'
                loading={classLoader}
                disabled={subjectid ? false : true}
              >
                <Input size="middle"
                  style={{ background: '#FAFAFA 0% 0% no-repeat padding-box', border: 'none', width: '100%', textAlign: 'left' }}
                  placeholder="Search batch" />
              </AutoComplete>
            </div>
            <div style={{ width: '100%' }}><p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Chapter</p>
              <div style={{ width: '100%' }}>
                <AutoComplete
                  allowClear={true}
                  dropdownMatchSelectWidth={252}
                  className='autocompletetoupload'
                  options={optionsChapter}
                  value={searchChapter}
                  onChange={handleChangeChapter}
                  onSelect={onSelectChapter}
                  onSearch={handleSearchChapter}
                  // disabled={true}
                  loading={chapterLoader}
                >
                  <Input size="middle" style={{ background: '#FAFAFA 0% 0% no-repeat padding-box', border: 'none', width: '100%' }} placeholder="Search Chapter" />
                </AutoComplete>
              </div>
            </div>

            <div className='generaltwocomponent udloadFilesDropdown' style={{ width: '100%' }}>
              <p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Topic</p>
              <AutoComplete
                getPopupContainer={(trigger) => trigger.parentElement}
                allowClear={topicName ? true : false}
                dropdownMatchSelectWidth={252}
                options={optionsTopic}
                value={topicName}
                onSelect={onSelectTopic}
                onSearch={handleSearchTopic}
                filterOption={false}
                className='autocompletetoupload'
                loading={topicLoader}
                disabled={chapterid ? false : true}
              >
                <Input size="middle"
                  style={{ background: '#FAFAFA 0% 0% no-repeat padding-box', border: 'none', width: '100%', textAlign: 'left' }}
                  placeholder="Select Topic" />
              </AutoComplete>
            </div>

            <div className='generaltwocomponent' style={{ width: '100%' }}> <p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Title</p>
              <div className='uploadfilesinput'>
                <Input size='middle' bordered={false} onChange={inputchanged} value={inputvalue} placeholder='Enter title' style={{
                  background: '#FAFAFA 0% 0% no-repeat padding-box', borderRadius: '4px',
                  opacity: '1'
                }}></Input></div>
            </div>

          </div>
        </div>

        <div style={{ width: '100%', marginTop: '3%' }}>
          <div style={{ width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <Button style={{ width: "122px", marginRight: "5px" }} type="default" onClick={handleCancel}>CANCEL</Button>
            <Button loading={loader} style={{ marginLeft: "5px", width: "122px" }} type="primary" onClick={successhandler} 
            // disabled={(/* (classid == selectedStd?.std_id || (Object.keys(uploadContent).length != 0 && classid != uploadContent?.classid)) && */ topicId && chapterid ? false : true)}
            >PUBLISH</Button>
            {console.log("AA-classid", classid, selectedStd?.std_id, topicId, chapterid, uploadContent)}

          </div>
        </div>
      </div>

    </Modal>
  )
}
const mapStateToProps = (state) => {
  const {
    subjects,
    chapterstofetch,
    selectedSubject,
    selectedStd,
    getChaptersList,
    getStdList,
    uploadContent,
    topicList,
    selectedChapter,
    selectedTopic,
    changedTitle

  } = state.digitalLibrary;
  return {
    subjects,
    chapterstofetch,
    selectedSubject,
    selectedStd,
    getChaptersList,
    getStdList,
    uploadContent,
    topicList,
    selectedChapter,
    selectedTopic,
    changedTitle

  };
};

const mapDispatchToProps = (dispatch) => ({
  updatepdf: (data) => dispatch(updatepdf(data)),
  subjectFilter: (data, callback) => dispatch(subjectFilter(data, callback)),
  fetchAdminLibraryData: () => dispatch(fetchAdminLibraryData()),
  updateSetType: (type) => dispatch(updateSetType(type)),
  fetchAdminChapterFilter: (value, classid, subjectid, callback) => dispatch(fetchAdminChapterFilter(value, classid, subjectid, callback)),
  fetchClasslist: (subid, chapterName) => dispatch(fetchClasslist(subid, chapterName)),
  postClone: (classid, id, topicId, chapterId, callback, successCallback) => dispatch(postClone(classid, id, topicId, chapterId, callback, successCallback)),
  fetchFilterTopic: (subId, stdId, chapterId, callback) => dispatch(fetchFilterTopic(subId, stdId, chapterId, callback)),
  fetchLibraryData: () => dispatch(fetchLibraryData()),
  postCreateTopic: (object, callback, successCallback) => dispatch(postCreateTopic(object, callback, successCallback)),
  updateFilterTopic: (data) => dispatch(updateFilterTopic(data)),
  updateAdminChapterInfo: (data) => dispatch(updateAdminChapterInfo(data)),
  updateTitle: (val) => dispatch(updateTitle(val)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps

)(CloneInformation);
